import { c as _c } from "react/compiler-runtime";
import { BookingsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { EventTypeEnum } from 'modules/calendar/events/enums/event-type-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { BOOKINGS_API } from '../api/bookings-api';
import { BookingRescheduleInterface } from '../types/bookings-interface';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
export function useBookingAction() {
  const $ = _c(16);
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.patch
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: fetcherPatch,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.delete
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] !== fetcherPatch) {
    t2 = (data, eventTypeGroup) => fetcherPatch(`${BOOKINGS_API}/${eventTypeGroup === EventTypeEnum.Group ? "group/reschedule" : "reschedule"}`, data);
    $[2] = fetcherPatch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const rescheduleBooking = t2;
  let t3;
  if ($[4] !== fetcherPatch) {
    t3 = (id, eventTypeGroup_0) => fetcherPatch(`${BOOKINGS_API}/${eventTypeGroup_0 === EventTypeEnum.Group ? `group/cancel?id=${id}` : `cancel?id=${id}`}`);
    $[4] = fetcherPatch;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const cancelBooking = t3;
  let t4;
  if ($[6] !== deleteFetcher) {
    t4 = id_0 => deleteFetcher(`${BOOKINGS_API}/delete?id=${id_0}`);
    $[6] = deleteFetcher;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const deleteBooking = t4;
  let t5;
  if ($[8] !== revalidateModules) {
    t5 = async hardRevalidate => {
      await revalidateModules([RequestModuleEnum.CalendarBookings], hardRevalidate);
    };
    $[8] = revalidateModules;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const revalidateBookings = t5;
  let t6;
  if ($[10] !== cancelBooking || $[11] !== deleteBooking || $[12] !== isFetching || $[13] !== rescheduleBooking || $[14] !== revalidateBookings) {
    t6 = {
      rescheduleBooking,
      isFetchingReschedule: isFetching,
      cancelBooking,
      deleteBooking,
      revalidateBookings
    };
    $[10] = cancelBooking;
    $[11] = deleteBooking;
    $[12] = isFetching;
    $[13] = rescheduleBooking;
    $[14] = revalidateBookings;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}